module.exports = __webpack_public_path__ + "static/media/10.dbb55bc0.png";